import React from 'react';
import { Modal, Box, Typography, Button, styled, Stack } from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '95%', lg: '30%' },
    maxHeight: { xs: '60%', md: '80%' },
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflowY: 'auto',
    borderRadius: '25px',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
};

const StyledModal = styled(Modal)({
    '& .MuiPaper-root': {
        outline: 'none',
        boxShadow: 'none',
        borderRadius: '25px',
    },
    '& .MuiModal-root': {
        outline: 'none',
        borderRadius: '25px',
    },
    '& *:focus': {
        outline: 'none',
    },
    borderRadius: '25px',
});

const ServiceInfo = ({ open, onClose, title, message, buttonLabel, onConfirm }) => {
    return (
        <StyledModal
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            }}
            aria-labelledby="service-info-title"
            aria-describedby="service-info-description"
        >
            <Box sx={style} onClick={(e) => e.stopPropagation()}>
                <Box sx={{ flexGrow: 1, overflowY: 'auto', mb: 4 }}>
                    <Typography id="service-info-title" variant="h6" component="h2">
                        {title}
                    </Typography>
                    <Typography whiteSpace="pre-line" sx={{ mt: 2 }}>
                        {message}
                    </Typography>
                </Box>

                <Stack
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'sticky',
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onConfirm}
                        sx={{
                            color: 'white',
                            textTransform: 'initial',
                            width: { xs: '100%', md: '50%' },
                            borderRadius: { xs: '10px', md: '' },
                        }}
                    >
                        {buttonLabel}
                    </Button>
                </Stack>
            </Box>
        </StyledModal>
    );
};

export default ServiceInfo;
